import { apiRequest } from '../../../api/client';
import { getApiToken } from '../../../api/authToken';

function ensureSuccess(data, fallback) {
  if (!data?.success) {
    throw new Error(data?.message || fallback);
  }
  return data;
}

export async function consumeAppMagicLink({ token }) {
  const data = await apiRequest('/api/auth/two-factor/magic-link/consume', {
    method: 'POST',
    body: { token },
  });
  return ensureSuccess(data, 'Failed to verify login link');
}

export async function requestAppMagicLink({ email, challengeId }) {
  const authToken = await getApiToken();
  return apiRequest('/api/auth/two-factor/magic-link/request', {
    token: authToken,
    method: 'POST',
    body: { email, challengeId },
  });
}

export async function requestAppSmsCode({ email, challengeId }) {
  const authToken = await getApiToken();
  return apiRequest('/api/auth/two-factor/sms/request', {
    token: authToken,
    method: 'POST',
    body: { email, challengeId },
  });
}

export async function consumeAppSmsCode({ challengeId, code }) {
  const authToken = await getApiToken();
  const data = await apiRequest('/api/auth/two-factor/sms/consume', {
    token: authToken,
    method: 'POST',
    body: { challengeId, code },
  });
  return ensureSuccess(data, 'Failed to verify login code');
}

export async function setMyMagicLinkRequirement({ requireMagicLink }) {
  const authToken = await getApiToken();
  const data = await apiRequest('/api/auth/two-factor/requirement', {
    token: authToken,
    method: 'POST',
    body: { requireMagicLink: Boolean(requireMagicLink) },
  });
  return ensureSuccess(data, 'Failed to update setting');
}

export async function setMyTwoFactorMethod({ method }) {
  const authToken = await getApiToken();
  const data = await apiRequest('/api/auth/two-factor/method', {
    token: authToken,
    method: 'POST',
    body: { method },
  });
  return ensureSuccess(data, 'Failed to update 2FA method');
}

export async function updateMyUserPhone({ phone }) {
  const authToken = await getApiToken();
  const data = await apiRequest('/api/auth/two-factor/phone', {
    token: authToken,
    method: 'POST',
    body: { phone: String(phone || '').trim() },
  });
  return ensureSuccess(data, 'Failed to update phone number');
}
